<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 16 17"
  >
    <path fill="currentColor" d="M16 8.5 0 17V0Z" />
  </svg>
</template>
